"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preferredSortPropType = exports.sortPropType = exports.alignPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var alignPropType = _propTypes.default.oneOf(['left', 'right']);

exports.alignPropType = alignPropType;

var sortPropType = _propTypes.default.oneOf(['ascending', 'descending', 'none']);

exports.sortPropType = sortPropType;

var preferredSortPropType = _propTypes.default.oneOf(['ascending', 'descending']);

exports.preferredSortPropType = preferredSortPropType;